import { BlocklyBlock } from "../../blocks/core/type/blocks";
import { TLessonBlocklyContent } from "../../models/courses/lesson";

export type TBlocklyToolboxBlocks = {
    blocks: BlocklyBlock[];
    // Ids de codification absents du référentiel : à montrer à l'éditeur,
    // jamais remplacés par un autre bloc.
    unknownFieldIds: number[];
};

export const TLessonBlocklyContentTOBlocklyBlocks = (
    content: TLessonBlocklyContent[] | undefined,
    getCodificationCodeById: (id: number) => string | undefined,
): TBlocklyToolboxBlocks => {
    const blocks: BlocklyBlock[] = [];
    const unknownFieldIds: number[] = [];
    for (const block of content ?? []) {
        const type = getCodificationCodeById(block.blocklyfield_id);
        if (type === undefined) {
            unknownFieldIds.push(block.blocklyfield_id);
            continue;
        }
        blocks.push({
            kind: "block",
            deletable: block.deletable,
            type,
            ...(block.max_usage > 0 && { maxUsage: block.max_usage }),
        });
    }
    return { blocks, unknownFieldIds };
};
